import {cn} from '../lib/utils'
import {cva, type VariantProps} from 'class-variance-authority'
import {type CSSProperties} from 'react'

export const loaderVariants = cva('grid h-full w-full place-items-center', {
  variants: {
    type: {
      bar: '',
    },
  },
  defaultVariants: {
    type: 'bar',
  },
})

export interface LoaderProps extends VariantProps<typeof loaderVariants> {
  style?: CSSProperties
  className?: string
  ariaLabel?: string
}

export function Loader({type = 'bar', style, className, ariaLabel}: Readonly<LoaderProps>) {
  return (
    <div
      className={loaderVariants({type, className})}
      style={style}
      data-testid="loader"
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
    >
      {type === 'bar' && (
        <div
          className={cn(
            'relative h-[2px] w-full max-w-[80px] min-w-[40px] overflow-hidden rounded-[1px] bg-current/20',
          )}
        >
          <div className="absolute right-full h-full w-[200%] animate-loading-bar bg-current" />
        </div>
      )}
    </div>
  )
}
